<template>
  <div>
    <app-header no_back="true" settings="systemZoom">esma</app-header>


    <div class="menu" style="">
      <div class="row" style="margin: 30px;">
        <div class="col-xs-2" style="">
        </div>
        <div class="col-xs-8" >
          <h2 style="text-align: left;">管理・マスタメニュー</h2>
        </div>
        <div class="col-xs-2" style="">
        </div>
      </div>
      <div class="row" style="margin: 30px;">
        <div class="col-xs-2" style="">
        </div>
        <div class="col-xs-4" style="">

          <router-link v-for="c in col1" :key="c.name"
            :disabled="c.path == '#' || c.disabled" tag="button"
            :to="c.path"
            type="button"
            style="margin: 5px; width: 80%;background: #5a99d2;color: white;font-weight: bold;"
            class="btn btn-primary btn-lg"
            >{{c.name}}</router-link>
        </div>
        <div class="col-xs-4" style="">
          <router-link v-for="c in col2" :key="c.name"
            :disabled="c.path == '#' || c.disabled" tag="button"
            :to="c.path"
            type="button"
            style="margin: 5px; width: 80%;background: #5a99d2;color: white;font-weight: bold;"
            class="btn btn-primary btn-lg"
            >{{c.name}}</router-link>
        </div>
        <div class="col-xs-2" style="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import MenuBtn from "../components/menu-btn";
import { utils } from "@/libs/utils";
import mixinMenuCommon from "@/mixins/mixin_menu_common";


import debug from "debug";
var debug_menu = debug("esma:menu");

Vue.component("menu-btn", MenuBtn);

import { bus } from "@/libs/bus";

export default {
  mixins: [mixinMenuCommon],
  //  name: 'Name here',
  data() {
    return {};
  },
  methods: {},
  computed: {
    col1(){
      return [
        {name:"部署・チーム",path:"/master_belongs", disabled:this.checkMenuUserPermission(this.acl.master_bel_mak_sys,this.permissionMode.BROWSE) == false},
        {name:"システム",path:"/master_system", disabled:this.checkMenuUserPermission(this.acl.master_bel_mak_sys,this.permissionMode.BROWSE) == false},
        {name:"メーカ",path:"/master_maker", disabled:this.checkMenuUserPermission(this.acl.master_bel_mak_sys,this.permissionMode.BROWSE) == false},
        {name:"ソフトウェア",path:"/master_software", disabled:this.checkMenuUserPermission(this.acl.master_bel_mak_sys,this.permissionMode.BROWSE) == false},
        //{name:"PWロック解除",path:"/pw_approval_history", disabled:this.checkMenuUserPermission(this.acl.master) == false  || utils.constants.COMPANY.ALL != Vue.localStorage.get("selectedCompany")},
      ]
    },
    col2(){
      return [
        {name:"メールメッセージ",path:"mail_message", disabled:this.checkMenuUserPermission(this.acl.master) == false},
        {name:"お知らせ",path:"/notice", disabled:this.checkMenuUserPermission(this.acl.master) == false},
        {name:"預り証出力",path:"/deposit_certificate_output", disabled:this.checkMenuUserPermission(this.acl.master) == false},
        {name:"過不足集計表",path:"/excess_deficiency_summary", disabled:this.checkMenuUserPermission(this.acl.master) == false},
        {name:"棚卸報告年度区分",path:"/inventory_reporting_period", disabled:this.checkMenuUserPermission(this.acl.master) == false},
      ]
    }

  },
  created() {},
  mounted() {

      this.$ajax.post('/ping', {}, (err, response) => {
          console.log("Ping response",{err,response})
      })

  },
};
</script>
<style scoped>

.menu {
  text-align: center;
}

.menu-btns {
  text-align: center;
  padding: 0px;
}

.menu-btns-container {
  text-align: center;
  max-width: 1100px;
  margin: auto;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// menu_configuration.vue?3a9987fe